import { OrganizationIntegrationAccountItem } from "@common/schemas/organization-connection-groups.schema";
import {
    OrganizationIntegrationStatus,
    resolveOrganizationIntegrationStatus,
} from "@common/helpers/organizationIntegrationStatus";
import { AlertIcon, CheckIcon } from "@icons";

type StatusIcon = typeof CheckIcon;

/** `null` means the status renders no glyph — and so no cell content at all. */
export const INTEGRATION_STATUS_ICONS: Record<
    OrganizationIntegrationStatus,
    StatusIcon | null
> = {
    connected: CheckIcon,
    unassigned: null,
    disconnected: AlertIcon,
};

export const resolveIntegrationStatus = (
    item: OrganizationIntegrationAccountItem,
): OrganizationIntegrationStatus =>
    resolveOrganizationIntegrationStatus({
        connectionStatus: item.connection.status,
        isAssigned: item.account.entity !== null,
    });

export const STATEMENTS_INDICATOR_LABEL = "Bank statements available";

export const getIntegrationStatusSyncedAt = (
    item: OrganizationIntegrationAccountItem,
): string | null =>
    item.account.lastSyncedAt ?? item.connection.lastSyncedAt ?? null;
